<div class="select-container" #dropdown>
  <div
    tabindex="0"
    class="select"
    (click)="toggleDropdown()"
    (keydown.enter)="toggleDropdown()"
    role="combobox"
    aria-labelledby="select button"
    aria-haspopup="listbox"
    aria-expanded="false"
    aria-controls="select-dropdown"
    >
    <div class="selected-item">
      @if (selectedOption()?.description) {
        {{ selectedOption()?.description }}
      } @else {
        <span class="dropdown-placeholder">{{ placeholder() }}</span>
      }
    </div>
  </div>

  @if (isDropdownOpen()) {
    <div class="dropdown-container">
      @if (showFilter()) {
        <div class="filter-container">
          <input class="dropdown-filter" type="text" [formControl]="filterCtrl()" [placeholder]="filterPlaceholder()" />
          @if (inputFilterIcon()) {
            <lib-icon [name]="inputFilterIcon()" class="search-icon" aria-hidden="false"></lib-icon>
          }
        </div>
      }
      <ul class="dropdown">
        @for (option of filteredOptions(); track option.value; let i = $index) {
          <li
            #optionElements
            [tabindex]="i ? -1 : 0"
            class="option"
            (click)="selectOption(option)"
            (keydown.enter)="selectOption(option)"
            (keydown.escape)="closeDropdown($event)"
            >
            {{ option.description }}
          </li>
        }
      </ul>
    </div>
  }
</div>
